import { create } from 'zustand';

/** Estado de interfaz global. Los datos del servidor viven en TanStack Query, nunca aca. */
interface EstadoUi {
  menuAbierto: boolean;
  alternarMenu: () => void;
  cerrarMenu: () => void;
}

export const useUiStore = create<EstadoUi>((set) => ({
  menuAbierto: false,
  alternarMenu: () => set((estado) => ({ menuAbierto: !estado.menuAbierto })),
  cerrarMenu: () => set({ menuAbierto: false }),
}));
